import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import {
    NavDropdown,
    ListGroup,
    Accordion,
    Card,
    Button
} from "react-bootstrap";
import NavbarLink from "./NavbarLink";
const Contracts = ({ CanI, NAV_GROUPS_TEXT, super_user }) => {
    const [state, setState] = useState({
        groups_view: false,
        groups_add: false
    });

    useEffect(() => {
        async function InitContracts() {
            setState({
                ...state,
                groups_view: await CanI("groups_view"),
                groups_add: await CanI("groups_add")
            });
        }
        InitContracts();
    }, []);
    const { groups_view, groups_add } = state;
    return (
        <NavDropdown.ItemText className="p-0">
            <Accordion>
                {super_user && (
                    <Card id="contracts-toggle-list">
                        <Card.Header>
                            <Accordion.Toggle
                                as={Button}
                                variant="light"
                                eventKey="contracts-toggle-list"
                            >
                                <span className="text-dark">
                                    <i className="fas fa-clipboard-list" />{" "}
                                    Contracts
                                </span>
                            </Accordion.Toggle>
                        </Card.Header>

                        <Accordion.Collapse eventKey="contracts-toggle-list">
                            <Card.Body className="p-0">
                                <ListGroup>
                                    <ListGroup.Item>
                                        <NavbarLink
                                            to="/app/contracts"
                                            className="dropdown-item"
                                            label={"View Contracts"}
                                        />
                                    </ListGroup.Item>
                                    <ListGroup.Item>
                                        <a
                                            href="/contracts/add"
                                            className="dropdown-item"
                                        >
                                            Add Contract
                                        </a>
                                    </ListGroup.Item>
                                </ListGroup>
                            </Card.Body>
                        </Accordion.Collapse>
                    </Card>
                )}
                {groups_view && (
                    <Card id="groups-toggle-list">
                        <Card.Header>
                            <Accordion.Toggle
                                as={Button}
                                variant="light"
                                eventKey="groups-toggle-list"
                            >
                                <span className="text-dark">
                                    <i className="fas fa-layer-group" />{" "}
                                    {NAV_GROUPS_TEXT}
                                </span>
                            </Accordion.Toggle>
                        </Card.Header>

                        <Accordion.Collapse eventKey="groups-toggle-list">
                            <Card.Body className="p-0">
                                <ListGroup>
                                    <ListGroup.Item>
                                        <NavbarLink
                                            to="/app/groups"
                                            className="dropdown-item"
                                            label={`View ${NAV_GROUPS_TEXT}`}
                                        />
                                    </ListGroup.Item>
                                </ListGroup>

                                <ListGroup>
                                    {groups_add && (
                                        <ListGroup.Item>
                                            <NavbarLink
                                                to="/app/groups/add"
                                                className="dropdown-item"
                                                label={`Add ${NAV_GROUPS_TEXT}`}
                                            />
                                        </ListGroup.Item>
                                    )}
                                </ListGroup>
                            </Card.Body>
                        </Accordion.Collapse>
                    </Card>
                )}
            </Accordion>
        </NavDropdown.ItemText>
    );
};

Contracts.propTypes = {
    CanI: PropTypes.func,
    NAV_GROUPS_TEXT: PropTypes.string,
    super_user: PropTypes.bool
};

export default Contracts;